import { render, staticRenderFns } from "./bossIndex.vue?vue&type=template&id=22ac51d1&scoped=true&"
import script from "./bossIndex.vue?vue&type=script&lang=js&"
export * from "./bossIndex.vue?vue&type=script&lang=js&"
import style0 from "./bossIndex.vue?vue&type=style&index=0&id=22ac51d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac51d1",
  null
  
)

export default component.exports